import { Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldErrorMessageComponent } from '../field-error-message/field-error-message.component';
import { ValidationErrors } from '@angular/forms';

@Component({
  selector: 'ds-form-field',
  imports: [CommonModule, FieldErrorMessageComponent],
  templateUrl: './form-field.component.html',
  styleUrls: ['./form-field.component.scss'],
})
export class FormFieldComponent {
  public id = input.required<string>();
  public label = input<string | undefined>('');
  public required = input<boolean>(false);
  public isInvalid = input<boolean>(false);
  public readonly = input<boolean>();
  public errors = input<ValidationErrors | null | undefined>({});

  public hintAfter = input<string>();

  protected showValidationMessages = computed(() => this.isInvalid() && Object.keys(this.errors() || []).length > 0);
}
